import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "../Pages/Login";
import ShopkeeperFullDetails from "../Pages/shopKeeper/ShopkeeperFullDetails";
import PageNotFound from "../Pages/PageNotFound";
function Authentication(props) {
  return (
    <Router>
      <Routes>
        <Route Component={Login} path="/" />
        <Route Component={Login} path="/signin" />
        <Route
          element={<ShopkeeperFullDetails />}
          path="/shopkeeper/:shopkeeperId/full-details"
        />
        <Route element={<PageNotFound />} path="*" />
      </Routes>
    </Router>
  );
}

export default Authentication;
